import React from 'react';
import { observer } from 'mobx-react';
import { CopyBlock, nord } from "react-code-blocks";

const Strapi = observer((props) => {


    let install = `npm install @apitraffic/strapi`;   
    let configure = `module.exports = [
  'plugin::apitraffic.apitraffic', 
]
`;
let envVars = `
API_TRAFFIC_TOKEN=${props.apiToken}
API_TRAFFIC_BUCKET=${props.store.SessionStore.getBucketSidFromUrl()}

`;   

  return (
    <>
        <h3 className="text-primary">Step {props.step}: Integrate into application</h3>
        <h4>Install SDK</h4>
        <p className="card-text">Use npm (or similar) to install @apitraffic/strapi.</p>
        <CopyBlock text={install} language='javascript' theme={nord} />

        <h4 className="mt-4">Configure Application</h4>
        <p className="card-text">In the config/middlewares.js file, include the following code to hook in the ApiTraffic SDK.</p>
        <CopyBlock text={configure} language='javascript' theme={nord} />

        <h4 className="mt-4">Set Environment Variables</h4>
        <p className="card-text">Before running, set the following environment variables. These variables can either be added to the .env file or set in the same way other environment variables are being set.<br/><br/> <strong>Complete the next step then set these variables.</strong></p>
        <CopyBlock text={envVars} language='javascript' theme={nord} />
    </>
  );
});

export default Strapi;